
(function() {
    'use strict';

    angular.module('app').filter('uniqueFilter', function() {

        return function (arr, field) {
            return _.uniq(arr, function(a) { return a[field]; });
        };
    });

}());